<!--eslint-disable-->
<template>
    <el-container>
        <el-header class="header" style="height: 40px; width: 100%">
            <span>Data de referência: </span>
            <el-date-picker v-model="chosenDate" type="date" :placeholder="timestampToDate()" format="dd/MM/yyyy" @change="getFinReportInDate"></el-date-picker>
            <el-button style="margin-left: 10px; width: 160px;" @click="saveSnapshot(0, 0, true)" type="primary">Salvar</el-button>
            <el-tooltip effect="dark" content="Adicionar novo fundo ao relatório" placement="bottom">
                <el-button class="add-fund" @click="dialogAddFundVisible = true" type="primary" size="medium">+</el-button>
            </el-tooltip>
        </el-header>
        <el-dialog title="Adicionar Fundo" :visible.sync="dialogAddFundVisible">
            <el-form :model="newFund">
                <el-form-item label="Tipo do fundo">
                    <el-select v-model="newFund.type">
                        <el-option key="prev" value="prev" label="Previdência"></el-option>
                        <el-option key="public_rf" value="public_rf" label="Public Equities benchmark RF"></el-option>
                        <el-option key="exclusive" value="exclusive" label="Fundo Exclusivo"></el-option>
                        <el-option key="public_rv" value="public_rv" label="Public Equities benchmark RV"></el-option>
                        <el-option key="pe" value="pe" label="Private Equities e PIPEs"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Nome do fundo">
                    <el-input v-model="newFund.name"></el-input>
                </el-form-item>
                <el-form-item label="Alias do fundo">
                    <el-input v-model="newFund.alias"></el-input>
                </el-form-item>
                <el-form-item label="Id do fundo">
                    <el-input v-model="newFund.id"></el-input>
                </el-form-item>
                <el-collapse>
                    <el-collapse-item>
                        <template slot="title">Taxa de administração</template>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="Tipo">
                                    <el-select v-model="newFund.admFeeType">
                                        <el-option key="perc" value="perc" label="Perc"></el-option>
                                        <el-option key="fixed" value="fixed" label="Fixed"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Valor" style="margin-left: 10px">
                                    <el-input v-model="newFund.admFeeValue"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item>
                        <template slot="title">Taxa do administrador</template>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="Tipo">
                                    <el-select v-model="newFund.administratorFeeType">
                                        <el-option key="perc" value="perc" label="Perc"></el-option>
                                        <el-option key="fixed" value="fixed" label="Fixed"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="Valor" style="margin-left: 10px">
                                    <el-input v-model="newFund.administratorFeeValue"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addFund">Adicionar</el-button>
            </span>
        </el-dialog>
        <el-main class="main">
            <el-table
                :data="tableData"
                border
                :cell-class-name="tableRowClassName"
                style="width: 1465px">
                <el-table-column
                    prop="pnl"
                    label="P&L"
                    width="348">
                    <template slot="header">
                        <p class="header-title">P&L</p>
                        <p class="header-details"></p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="total"
                    label="TOTAL"
                    :formatter="numberFormatter"
                    align="right"
                    width="186">
                    <template slot="header">
                        <p class="header-title">TOTAL</p>
                        <p class="header-details"></p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="publicEquitiesRF"
                    label="Public Equities"
                    :formatter="numberFormatter"
                    align="right"
                    width="186">
                    <template slot="header">
                        <p class="header-title" >
                            Public Equities
                            <el-tooltip placement="right-start">
                                {{ disabled }}
                                <template slot="content">
                                    <p v-for="item in listOfFunds.public_rf" :key="item"> {{ item }} </p>
                                </template>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p class="header-details">benchmark RF</p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="publicEquitiesRV"
                    label="Public Equities"
                    :formatter="numberFormatter"
                    align="right"
                    width="186">
                    <template slot="header">
                        <p class="header-title">
                            Public Equities
                            <el-tooltip placement="right-start">
                                <template slot="content">
                                    <p v-for="item in listOfFunds.public_rv" :key="item"> {{ item }} </p>
                                </template>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p class="header-details">benchmark RV</p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="previdencia"
                    label="Previdência"
                    :formatter="numberFormatter"
                    align="right"
                    width="186">
                    <template slot="header">
                        <p class="header-title">
                            Previdência
                            <el-tooltip placement="right-start">
                                <template slot="content">
                                    <p v-for="item in listOfFunds.prev" :key="item"> {{ item }} </p>
                                </template>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p class="header-details"></p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="privateEquities"
                    label="Private Equities"
                    align="right"
                    :formatter="numberFormatter"
                    width="186">
                    <template slot="header">
                        <p class="header-title">
                            Private Equities
                            <el-tooltip placement="right-start">
                                <template slot="content">
                                    <p v-for="item in listOfFunds.pe" :key="item"> {{ item }} </p>
                                </template>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p class="header-details"></p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="exclusivo"
                    label="Fundo Exclusivo"
                    align="right"
                    :formatter="numberFormatter"
                    width="186">
                    <template slot="header">
                        <p class="header-title">
                            Fundo Exclusivo
                            <el-tooltip placement="right-start">
                                <template slot="content">
                                    <p v-for="item in listOfFunds.exclusive" :key="item"> {{ item }} </p>
                                </template>
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </p>
                        <p class="header-details"></p>
                    </template>
                    <template slot-scope="scope">
                        <EditableColumn v-if="isEditable(scope.$index, scope.row, scope.column)" :scope="scope" v-on:saveSnapshot="saveSnapshot"></EditableColumn>
                        <FixedColumn v-else :scope="scope"></FixedColumn>
                    </template>
                </el-table-column>
            </el-table> 
        </el-main>
        <el-footer>
            <el-button class="download-button" @click="saveAum" type="primary" size="mini">Exportar Aum</el-button>
            <el-button class="download-button" @click="saveDistributor" type="primary" size="mini">Exportar Distributor</el-button>
        </el-footer>
    </el-container>
</template>

<script>
/* eslint-disable */
import fb from '@/services/firebaseConfig'
import formatters from '@/services/formatters';
import EditableColumn from '@/components/EditableColumn.vue'
import FixedColumn from '@/components/FixedColumn.vue'
import firebase from 'firebase/app'
import 'firebase/functions'

const db = fb.db


export default {
    data() {
        return {
            snapshot: [],
            editing: null,
            refDate: null,
            costs: {
                people: null,
                rent: null,
                others: null,
                taxes_perc: null 
            },
            chosenDate: null,
            listOfFunds: Object,
            disabled: true,
            dialogAddFundVisible: false,
            newFund: {},
            fundTypesDocId: {}
        }
    },
    components: {
        EditableColumn,
        FixedColumn
    },
    methods: {
        async addFund() {
            this.newFund.id = parseFloat(this.newFund.id) == NaN ? this.newFund.id : parseFloat(this.newFund.id)
            this.newFund.administratorFeeValue = parseFloat(this.newFund.administratorFeeValue) == NaN ? this.newFund.administratorFeeValue : parseFloat(this.newFund.administratorFeeValue)
            this.newFund.admFeeValue = parseFloat(this.newFund.admFeeValue) == NaN ? this.newFund.admFeeValue : parseFloat(this.newFund.admFeeValue)

            // Salvar novo fundo no banco
            let firebaseDocId = this.fundTypesDocId[this.newFund.type]
            let firebaseDoc = await db.collection('finReportFundTypes').doc(firebaseDocId).get()
            let fundsFromDoc = firebaseDoc.data().performit_fund_ids
            fundsFromDoc.push({
                adm_fee: {
                    administrator_fee: {
                        type: this.newFund.administratorFeeType,
                        value: this.newFund.administratorFeeValue
                    },
                    type: this.newFund.admFeeType,
                    value: this.newFund.admFeeValue
                },
                fund_alias: this.newFund.alias,
                fund_id: this.newFund.id,
                fund_name: this.newFund.name
            })
            db.collection('finReportFundTypes').doc(firebaseDocId).set({
                performit_fund_ids: fundsFromDoc
            }, { merge: true })

            this.dialogAddFundVisible = false
        },
        numberFormatterCurrency(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'currency',0)
        },
        numberFormatterPercent(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'percent', 0)
        },
        numberFormatterDecimal(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'decimal', 1)
        },
        numberFormatterPercent1(row, column, cellValue) {
            return formatters.numberFormatter(cellValue, 1, 'percent', 2)
        },
        numberFormatter(row, column, cellValue, index) {
            
            // percentCells: sem casas decimais
            var percentCells = [1, 6, 7, 19]
            
            //smallPercentCells: 1 casa decimal
            var smallPercentCells = [3, 5, 9, 11, 14, 16, 18, 25]
            
            //miniPercentCell: 2 casas decimais
            var miniPercentCells = [12]
            
            var currencyCells = [0, 2, 4, 8, 10, 13, 15, 17, 21, 22, 23, 24]
            if(percentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 0)
            }
            if(smallPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 1)
            }
            if(miniPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 2)
            }
            if(currencyCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'currency',0)
            }
            
        },
        timestampToDate() {
            return new Date(this.refDate.seconds * 1000).toLocaleDateString("pt-BR")
        },
        timestampToISOString(timestamp) {
            return new Date(timestamp.seconds * 1000).toISOString().split('T')[0]
        },
        tableRowClassName({row, column, rowIndex, columnIndex}) {
            var detailsIndexes = [1, 3, 5, 6, 8, 9, 10, 12, 13, 15, 17, 18, 20, 21, 22, 23, 25, 26]
            var receitaLiquidaIndexes = [16, 17, 18]
            var aumIndexes = [0, 1]
            var lucroIndexes = [24, 25, 26]
            var rebateIndexes = [9, 11]
            var classes = ' cell-size'
            
            if(detailsIndexes.includes(rowIndex)) {
                classes += ' details-row';
            }
            if(aumIndexes.includes(rowIndex)) {
                classes += ' aum-row';
            }
            if(receitaLiquidaIndexes.includes(rowIndex)) {
                classes += ' rec-liq-row';
            }
            if(lucroIndexes.includes(rowIndex)) {
                classes += ' lucro-row';
            }
            if(rebateIndexes.includes(rowIndex)) {
                classes += ' rebate-row'
            }
            return classes;
        },
        isEditable(index, row, column) {
            if(index == 15 && column.property == "total") return true
            if((index == 21 || index == 22 || index == 23) && column.property == "total") return true
            if(index == 10 && column.property == "previdencia") return true
            return false
        },
        async saveSnapshot(value, scope, commited) {
            
            if(scope.$index == 10) {
                this.snapshot.filter(snap => snap.type_name == "prev")[0].avgRebate = Number(value)
                
                var savePrevAvgRebate = firebase.functions().httpsCallable('savePrevAvgRebate')
                try {
                    var result = await savePrevAvgRebate({avgRebate: Number(value)})
                } catch (err) {
                    this.$root.$emit('showError', 'Entre em contato com um administrador para validar a sua conta.', 'error')
                    // this.$alert(err)
                }
            }
            
            if(scope.$index == 21 || scope.$index == 22 || scope.$index == 23 || scope.$index == 15) {
                
                let companyCostsMap = {
                    'Alíquota de Imposto': 'taxes_perc',
                    'Pessoal': 'people',
                    'Ocupação': 'rent',
                    'Outros': 'others'
                }
                
                let category = companyCostsMap[scope.row.pnl]
                this.costs[category] = Number(value)
                
                var saveCompanyCosts = firebase.functions().httpsCallable('saveCompanyCosts')
                try {
                    var result = await saveCompanyCosts({category: category, value: Number(value)})
                } catch (err) {
                    this.$alert(err)
                }
            }
            
            let costs = {
                people: this.costs.people,
                rent: this.costs.rent,
                others: this.costs.others,
                taxes_perc: this.costs.taxes_perc
            }
            
            let saveUserChangesInFinReport = firebase.functions().httpsCallable('saveUserChangesInFinReport')
            try {
                var result = await saveUserChangesInFinReport({refDate: this.refDate, snapshot: this.snapshot, costs: costs, commited: commited})
            } catch (err) {
                this.$root.$emit('showError', 'Ocorreu um erro: ' + err, 'error')
            }
        },
        getFinReportInDate() {
            db.collection('finReportSnapshot')
                .where('_refDate', '<=', this.chosenDate)
                .orderBy('_refDate', 'desc')
                .orderBy('_lastUpdate', 'desc')
                .limit(1)
                .onSnapshot(
                    q => {
                        let people, rent, others, taxes_perc
                        let _refDate;
                        let snap;
                        
                        q.forEach(doc => {
                            _refDate = doc.data()._refDate
                            snap = doc.data().snapshot
                            people = doc.data().people
                            rent = doc.data().rent
                            others = doc.data().others
                            taxes_perc = doc.data().taxes_perc
                        })
                        this.snapshot = snap
                        this.refDate = _refDate
                        this.chosenDate = new Date(_refDate.seconds * 1000)
                        this.costs = {
                            people: people,
                            rent: rent,
                            others: others,
                            taxes_perc: taxes_perc
                        }
                })
        },
        async saveAum() {
            await this.getFiles('aum')
        },
        async saveDistributor() {
            await this.getFiles('distributor')
        },
        async getFiles(base) {
            let getCsvFiles = firebase.functions().httpsCallable('getCsvFiles')
            try{
                let csvFiles = await getCsvFiles({base: base, refDate: this.refDate})
                let csv = csvFiles.data.csv.replace(/,/g, ';').replace(/\./g, ',')
                
                const url = window.URL.createObjectURL(new Blob([csv]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', base + '_' + this.timestampToISOString(this.refDate) +'.csv')
                document.body.appendChild(link)
                link.click()
            } catch (err) {
                this.$root.$emit('showError', 'Erro ao exportar a base.', 'error')
            }
        },
    },
    computed: {
        tableData() {
            
            if(this.snapshot === undefined || this.snapshot.length == 0 || this.refDate === undefined) return
            
    //region CALCULO
            
        //#region AUM
            
            // Total AUM
            let totalAum = 0
            this.snapshot.forEach(snap => {
                totalAum += snap.aum
            })
            
            // Linha 0: AUM
            let totalAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].aum
            let totalAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].aum
            let totalAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].aum
            let totalAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].aum
            let totalAumExclusivo = this.snapshot.filter(snap => snap.type_name == 'exclusive')[0].aum
            
            // Linha 1: % Total
            let totalPercPublicRf = totalAumPublicRf/totalAum;
            let totalPercPublicRv = totalAumPublicRv/totalAum;
            let totalPercPrev = totalAumPrev/totalAum;
            let totalPercPe = totalAumPe/totalAum;
            let totalPercExclusivo = totalAumExclusivo/totalAum;
            
        //#endregion AUM
            
            ////////////////////////////////////////////////////////////////////
            
        //region TAXA DE ADM 
            
            // Linha 3: % AUM
            let receitaBrutaAdmPercAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgTxAdm
            let receitaBrutaAdmPercAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgTxAdm;
            let receitaBrutaAdmPercAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgTxAdm;
            let receitaBrutaAdmPercAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgTxAdm;
            let receitaBrutaAdmPercAumExclusivo = this.snapshot.filter(snap => snap.type_name == 'exclusive')[0].avgTxAdm;
            
            // Linha 2: (+) Taxa de ADM Bruta
            let receitaBrutaAdmPublicRf = totalAumPublicRf * receitaBrutaAdmPercAumPublicRf;
            let receitaBrutaAdmPublicRv = totalAumPublicRv * receitaBrutaAdmPercAumPublicRv;
            let receitaBrutaAdmPrev = totalAumPrev * receitaBrutaAdmPercAumPrev;
            let receitaBrutaAdmPe = totalAumPe * receitaBrutaAdmPercAumPe;
            let receitaBrutaAdmExclusivo = totalAumExclusivo * receitaBrutaAdmPercAumExclusivo;
            
            let receitaBrutaAdmTotal = receitaBrutaAdmPe + receitaBrutaAdmPrev + receitaBrutaAdmPublicRf + receitaBrutaAdmPublicRv + receitaBrutaAdmExclusivo;
            let receitaBrutaAdmPercTotal = receitaBrutaAdmTotal/totalAum;
            
            //endregion TAXA DE ADM 
            
            ////////////////////////////////////////////////////////////////////
            
        //region ADMINISTRADORES
            
            // Linha 5: % AUM
            let administradoresPercAumPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgTxAdministrator
            let administradoresPercAumPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgTxAdministrator
            let administradoresPercAumPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgTxAdministrator
            let administradoresPercAumPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgTxAdministrator
            let administradoresPercAumExclusivo = this.snapshot.filter(snap => snap.type_name == 'exclusive')[0].avgTxAdministrator
                
            // Linha 4: (-) ADMINISTRADORES
            let administradoresPublicRf = administradoresPercAumPublicRf * totalAumPublicRf
            let administradoresPublicRv = administradoresPercAumPublicRv * totalAumPublicRv
            let administradoresPrev = administradoresPercAumPrev * totalAumPrev
            let administradoresPe = administradoresPercAumPe * totalAumPe
            let administradoresExclusivo = administradoresPercAumExclusivo * totalAumExclusivo
            let administradoresTotal = administradoresPe + administradoresPrev + administradoresPublicRf + administradoresPublicRv + administradoresExclusivo
            let administradoresPercAumTotal = administradoresTotal/totalAum
            
            // Linha 6: % Taxa de ADM Bruta
            let receitaPosAdministradoresPercPublicRf = administradoresPublicRf/receitaBrutaAdmPublicRf
            let receitaPosAdministradoresPercPublicRv = administradoresPublicRv/receitaBrutaAdmPublicRv
            let receitaPosAdministradoresPercPrev = administradoresPrev/receitaBrutaAdmPrev
            let receitaPosAdministradoresPercPe = administradoresPe/receitaBrutaAdmPe
            let receitaPosAdministradoresPercExclusivo = administradoresExclusivo/receitaBrutaAdmExclusivo
            let receitaPosAdministradoresPercTotal = administradoresTotal/receitaBrutaAdmTotal
            
            // Auxiliares
            let receitaPosAdministradoresPublicRf = receitaBrutaAdmPublicRf - administradoresPublicRf
            let receitaPosAdministradoresPublicRv = receitaBrutaAdmPublicRv - administradoresPublicRv
            let receitaPosAdministradoresPrev = receitaBrutaAdmPrev - administradoresPrev
            let receitaPosAdministradoresPe = receitaBrutaAdmPe - administradoresPe
            let receitaPosAdministradoresExclusivo = receitaBrutaAdmExclusivo - administradoresExclusivo
            
            //endregion ADMINISTRADORES
            
            ////////////////////////////////////////////////////////////////////
            
        //region REBATES
            
            // Linha 9: % Distribuidores
            let distribuidoresPercPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].aumDist/totalAumPublicRf
            let distribuidoresPercPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].aumDist/totalAumPublicRv
            let distribuidoresPercPrev = 1
            let distribuidoresPercPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].aumDist/totalAumPe
            let distribuidoresPercExclusivo = this.snapshot.filter(snap => snap.type_name == 'exclusive')[0].aumDist/totalAumExclusivo
            
            // Linha 10: Rebate Médio
            let rebateMedioPublicRf = this.snapshot.filter(snap => snap.type_name == 'public_rf')[0].avgRebate
            let rebateMedioPublicRv = this.snapshot.filter(snap => snap.type_name == 'public_rv')[0].avgRebate
            let rebateMedioPrev = this.snapshot.filter(snap => snap.type_name == 'prev')[0].avgRebate
            let rebateMedioPe = this.snapshot.filter(snap => snap.type_name == 'pe')[0].avgRebate
            let rebateMedioExclusivo = this.snapshot.filter(snap => snap.type_name == 'exclusive')[0].avgRebate
            
            // Linha 7: (-) REBATES
            let rebatePublicRf = receitaPosAdministradoresPublicRf * distribuidoresPercPublicRf * rebateMedioPublicRf
            let rebatePublicRv = receitaPosAdministradoresPublicRv * distribuidoresPercPublicRv * rebateMedioPublicRv
            let rebatePrev = receitaPosAdministradoresPrev * distribuidoresPercPrev * rebateMedioPrev
            let rebatePe = receitaPosAdministradoresPe * distribuidoresPercPe * rebateMedioPe
            let rebateExclusivo = receitaPosAdministradoresExclusivo * distribuidoresPercExclusivo * rebateMedioExclusivo
        
            let totalRebate = rebatePublicRf + rebatePublicRv + rebatePrev + rebatePe + rebateExclusivo
            
            // Linha 8: % Taxa de ADM Bruta
            let receitaBrutaPercPublicRf = rebatePublicRf/receitaBrutaAdmPublicRf
            let receitaBrutaPercPublicRv = rebatePublicRv/receitaBrutaAdmPublicRv
            let receitaBrutaPercPrev = rebatePrev/receitaBrutaAdmPrev
            let receitaBrutaPercPe = rebatePe/receitaBrutaAdmPe
            let receitaBrutaPercExclusivo = rebateExclusivo/receitaBrutaAdmExclusivo
            let receitaBrutaPercTotal = totalRebate/receitaBrutaAdmTotal
            
            //#endregion REBATES
            
            ////////////////////////////////////////////////////////////////////
            
        //region TAXA ADM LÍQUIDA
            
            // Linha 11: (=) Taxa de ADM Líquida
            let receitaBrutaPublicRf = receitaPosAdministradoresPublicRf - rebatePublicRf
            let receitaBrutaPublicRv = receitaPosAdministradoresPublicRv - rebatePublicRv
            let receitaBrutaPrev = receitaPosAdministradoresPrev - rebatePrev
            let receitaBrutaPe = receitaPosAdministradoresPe - rebatePe
            let receitaBrutaExclusivo = receitaPosAdministradoresExclusivo - rebateExclusivo
            let receitaBrutaTotal = receitaBrutaPublicRf + receitaBrutaPublicRv + receitaBrutaPrev + receitaBrutaPe + receitaBrutaExclusivo
            
            // Linha 13: % AUM
            let receitaBrutaPercAumPublicRf = receitaBrutaPublicRf/totalAumPublicRf
            let receitaBrutaPercAumPublicRv = receitaBrutaPublicRv/totalAumPublicRv
            let receitaBrutaPercAumPrev = receitaBrutaPrev/totalAumPrev
            let receitaBrutaPercAumPe = receitaBrutaPe/totalAumPe
            let receitaBrutaPercAumExclusivo = receitaBrutaExclusivo/totalAumExclusivo
            let receitaBrutaPercAumTotal = receitaBrutaTotal/totalAum
            
            // Linha 12: % Taxa de ADM Líquida
            let receitaBrutaPosRebatesPercAumPublicRf = receitaBrutaPublicRf/receitaBrutaAdmPublicRf
            let receitaBrutaPosRebatesPercAumPublicRv = receitaBrutaPublicRv/receitaBrutaAdmPublicRv
            let receitaBrutaPosRebatesPercAumPrev = receitaBrutaPrev/receitaBrutaAdmPrev
            let receitaBrutaPosRebatesPercAumPe = receitaBrutaPe/receitaBrutaAdmPe
            let receitaBrutaPosRebatesPercAumExclusivo = receitaBrutaExclusivo/receitaBrutaAdmExclusivo
            let receitaBrutaPosRebatesPercAumTotal = receitaBrutaTotal/receitaBrutaAdmTotal
            
            //#endregion TAXA ADM LÍQUIDA
            
            ////////////////////////////////////////////////////////////////////
            
        //region IMPOSTOS
            
            // Linha 15: Alíquota de Imposto
            let impostosPercPublicRf = 0
            let impostosPercPublicRv = 0
            let impostosPercPrev = 0
            let impostosPercPe = 0
            let impostosPercExclusivo = 0
            let impostosPercTotal = this.costs.taxes_perc
            
            // Linha 14: (-) IMPOSTOS
            let impostosPublicRf = receitaBrutaPublicRf * impostosPercTotal
            let impostosPublicRv = receitaBrutaPublicRv * impostosPercTotal
            let impostosPrev = receitaBrutaPrev * impostosPercTotal
            let impostosPe = receitaBrutaPe * impostosPercTotal
            let impostosExclusivo = receitaBrutaExclusivo * impostosPercTotal
            let impostosTotal = impostosPublicRf + impostosPublicRv + impostosPrev + impostosPe + impostosExclusivo
            // let impostosPercTotal = impostosTotal/receitaBrutaTotal
            
            //#endregion IMPOSTOS
            
            ////////////////////////////////////////////////////////////////////
            
        //region RECEITA LÍQUIDA
            
            // Linha 16: Receita Liquida
            let receitaLiquidaPublicRf = receitaBrutaPublicRf - impostosPublicRf
            let receitaLiquidaPublicRv = receitaBrutaPublicRv - impostosPublicRv
            let receitaLiquidaPrev = receitaBrutaPrev - impostosPrev
            let receitaLiquidaPe = receitaBrutaPe - impostosPe
            let receitaLiquidaExclusivo = receitaBrutaExclusivo - impostosExclusivo
            let receitaLiquidaTotal = receitaLiquidaPublicRf + receitaLiquidaPublicRv + receitaLiquidaPrev + receitaLiquidaPe + receitaLiquidaExclusivo
            
            // Linha 17: % AUM
            let receitaLiquidaPercAumPublicRf = receitaLiquidaPublicRf/totalAumPublicRf
            let receitaLiquidaPercAumPublicRv = receitaLiquidaPublicRv/totalAumPublicRv
            let receitaLiquidaPercAumPrev = receitaLiquidaPrev/totalAumPrev
            let receitaLiquidaPercAumPe = receitaLiquidaPe/totalAumPe
            let receitaLiquidaPercAumExclusivo = receitaLiquidaExclusivo/totalAumExclusivo
            let receitaLiquidaPercAumTotal = receitaLiquidaTotal/totalAum
            
            // Linha 18: % Total
            let receitaLiquidaPercTotalPublicRf = receitaLiquidaPublicRf/receitaLiquidaTotal
            let receitaLiquidaPercTotalPublicRv = receitaLiquidaPublicRv/receitaLiquidaTotal
            let receitaLiquidaPercTotalPrev = receitaLiquidaPrev/receitaLiquidaTotal
            let receitaLiquidaPercTotalPe = receitaLiquidaPe/receitaLiquidaTotal
            let receitaLiquidaPercTotalExclusivo = receitaLiquidaExclusivo/receitaLiquidaTotal
            
            //#endregion RECEITA LÍQUIDA
            
            ////////////////////////////////////////////////////////////////////
            
        //region DESPESAS
            
            // Linha 21: Pessoal
            let despesasPessoa = this.costs.people
            
            // Linha 22: Ocupação
            let despesasOcupacao = this.costs.rent
            
            // Linha 23: Outros
            let despesasOutros = this.costs.others
            
            // Linha 19: (-) Despesas
            let totalDespesas = despesasPessoa + despesasOcupacao + despesasOutros
            
            // Linha 20: % Receita Líquida
            let despesasPercReceitaLiquida = totalDespesas/receitaLiquidaTotal
            
            //#endregion DESPESAS
            
            ////////////////////////////////////////////////////////////////////
            
        //region LUCRO LÍQUIDO
            
            // Linha 24: (=) Lucro Líquido
            let lucroLiquido = receitaLiquidaTotal - totalDespesas
            
            // Linha 25: % AUM
            let lucroLiquidoPercAum = lucroLiquido/totalAum
            
            // Linha 26: % Mg. Líquida
            let mgLiquida = lucroLiquido/receitaLiquidaTotal
            
            //#endregion LUCRO LÍQUIDO
            
    //#endregion CALCULO
            
            let aux = [
                {pnl:'AUM', total: totalAum, publicEquitiesRF: totalAumPublicRf, publicEquitiesRV: totalAumPublicRv, previdencia: totalAumPrev, privateEquities: totalAumPe, exclusivo: totalAumExclusivo},
                {pnl:'% TOTAL' , total: 0, publicEquitiesRF: totalPercPublicRf, publicEquitiesRV: totalPercPublicRv, previdencia: totalPercPrev, privateEquities: totalPercPe, exclusivo: totalPercExclusivo},
                {pnl:'(+) Taxa de ADM Bruta' , total: receitaBrutaAdmTotal, publicEquitiesRF: receitaBrutaAdmPublicRf, publicEquitiesRV: receitaBrutaAdmPublicRv, previdencia: receitaBrutaAdmPrev, privateEquities: receitaBrutaAdmPe, exclusivo: receitaBrutaAdmExclusivo},
                {pnl:'% AUM' , total: receitaBrutaAdmPercTotal, publicEquitiesRF: receitaBrutaAdmPercAumPublicRf, publicEquitiesRV: receitaBrutaAdmPercAumPublicRv, previdencia: receitaBrutaAdmPercAumPrev, privateEquities: receitaBrutaAdmPercAumPe, exclusivo: receitaBrutaAdmPercAumExclusivo},
                {pnl:'(-) ADMINISTRADORES' , total: administradoresTotal, publicEquitiesRF: administradoresPublicRf, publicEquitiesRV: administradoresPublicRv, previdencia: administradoresPrev, privateEquities: administradoresPe, exclusivo: administradoresExclusivo},
                {pnl:'% AUM' , total: administradoresPercAumTotal, publicEquitiesRF: administradoresPercAumPublicRf, publicEquitiesRV: administradoresPercAumPublicRv, previdencia: administradoresPercAumPrev, privateEquities: administradoresPercAumPe, exclusivo: administradoresPercAumExclusivo},
                {pnl:'% Taxa de ADM Bruta' , total: receitaPosAdministradoresPercTotal, publicEquitiesRF: receitaPosAdministradoresPercPublicRf, publicEquitiesRV: receitaPosAdministradoresPercPublicRv, previdencia: receitaPosAdministradoresPercPrev, privateEquities: receitaPosAdministradoresPercPe, exclusivo: receitaPosAdministradoresPercExclusivo},
                {pnl:'(-) REBATES' , total: totalRebate, publicEquitiesRF: rebatePublicRf, publicEquitiesRV: rebatePublicRv, previdencia: rebatePrev, privateEquities: rebatePe, exclusivo: rebateExclusivo},
                {pnl:'% Taxa de ADM Bruta' , total: receitaBrutaPercTotal, publicEquitiesRF: receitaBrutaPercPublicRf, publicEquitiesRV: receitaBrutaPercPublicRv, previdencia: receitaBrutaPercPrev, privateEquities: receitaBrutaPercPe, exclusivo: receitaBrutaPercExclusivo},
                {pnl:'% Distribuidores' , total: 0, publicEquitiesRF: distribuidoresPercPublicRf, publicEquitiesRV: distribuidoresPercPublicRv, previdencia: distribuidoresPercPrev, privateEquities: distribuidoresPercPe, exclusivo: distribuidoresPercExclusivo},
                {pnl:'Rebate Médio',  total: 0, publicEquitiesRF: rebateMedioPublicRf, publicEquitiesRV: rebateMedioPublicRv, previdencia: rebateMedioPrev, privateEquities: rebateMedioPe, exclusivo: rebateMedioExclusivo},
                {pnl:'(=) Taxa de ADM Líquida' , total: receitaBrutaTotal, publicEquitiesRF: receitaBrutaPublicRf, publicEquitiesRV: receitaBrutaPublicRv, previdencia: receitaBrutaPrev, privateEquities: receitaBrutaPe, exclusivo: receitaBrutaExclusivo},
                {pnl:'% Taxa de ADM Bruta' , total: receitaBrutaPosRebatesPercAumTotal, publicEquitiesRF: receitaBrutaPosRebatesPercAumPublicRf, publicEquitiesRV: receitaBrutaPosRebatesPercAumPublicRv, previdencia: receitaBrutaPosRebatesPercAumPrev, privateEquities: receitaBrutaPosRebatesPercAumPe, exclusivo: receitaBrutaPosRebatesPercAumExclusivo},
                {pnl:'% AUM' , total: receitaBrutaPercAumTotal, publicEquitiesRF: receitaBrutaPercAumPublicRf, publicEquitiesRV: receitaBrutaPercAumPublicRv, previdencia: receitaBrutaPercAumPrev, privateEquities: receitaBrutaPercAumPe, exclusivo: receitaBrutaPercAumExclusivo},
                {pnl:'(-) IMPOSTOS' , total: impostosTotal, publicEquitiesRF: impostosPublicRf, publicEquitiesRV: impostosPublicRv, previdencia: impostosPrev, privateEquities: impostosPe, exclusivo: impostosExclusivo},
                {pnl:'Alíquota de Imposto' , total: impostosPercTotal, publicEquitiesRF: impostosPercPublicRf, publicEquitiesRV: impostosPercPublicRv, previdencia: impostosPercPrev, privateEquities: impostosPercPe, exclusivo: impostosPercExclusivo},
                {pnl:'(=) Receita Líquida' , total: receitaLiquidaTotal, publicEquitiesRF: receitaLiquidaPublicRf, publicEquitiesRV: receitaLiquidaPublicRv, previdencia: receitaLiquidaPrev, privateEquities: receitaLiquidaPe, exclusivo: receitaLiquidaExclusivo},
                {pnl:'% AUM' , total: receitaLiquidaPercAumTotal, publicEquitiesRF: receitaLiquidaPercAumPublicRf, publicEquitiesRV: receitaLiquidaPercAumPublicRv, previdencia: receitaLiquidaPercAumPrev, privateEquities: receitaLiquidaPercAumPe, exclusivo: receitaLiquidaPercAumExclusivo},
                {pnl:'% Total' , total: 0, publicEquitiesRF: receitaLiquidaPercTotalPublicRf, publicEquitiesRV: receitaLiquidaPercTotalPublicRv, previdencia: receitaLiquidaPercTotalPrev, privateEquities: receitaLiquidaPercTotalPe, exclusivo: receitaLiquidaPercTotalExclusivo},
                {pnl:'(-) Despesas' , total: totalDespesas, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'% Receita Liquida', total: despesasPercReceitaLiquida, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'Pessoal' , total: despesasPessoa, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'Ocupação' , total: despesasOcupacao, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'Outros' , total: despesasOutros, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'(=) Lucro Líquido' , total: lucroLiquido, publicEquitiesRF: 0, publicEquitiesRV: 0, previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'% AUM' , total: lucroLiquidoPercAum, publicEquitiesRF: 0, publicEquitiesRV:0 , previdencia: 0, privateEquities: 0, exclusivo: 0},
                {pnl:'Mg. Líquida (%)' , total: mgLiquida, publicEquitiesRF: 0, publicEquitiesRV:0 , previdencia: 0, privateEquities: 0, exclusivo: 0}
            ]
            
            return aux
        },
    },
    created() {
        
        db.collection('finReportSnapshot')
            .orderBy('_refDate', 'desc')
            .orderBy('_lastUpdate', 'desc')
            .limit(1)
            .onSnapshot(
                q => {
                    let people, rent, others, taxes_perc
                    let _refDate;
                    let snap;
                    
                    q.forEach(doc => {
                        _refDate = doc.data()._refDate
                        snap = doc.data().snapshot
                        people = doc.data().people
                        rent = doc.data().rent
                        others = doc.data().others
                        taxes_perc = doc.data().taxes_perc
                    })
                    this.snapshot = snap
                    this.refDate = _refDate
                    this.chosenDate = new Date(_refDate.seconds * 1000)
                    this.costs = {
                        people: people,
                        rent: rent,
                        others: others,
                        taxes_perc: taxes_perc
                    }
            })
    },
    beforeCreate() {
        db.collection('finReportFundTypes')
            .onSnapshot(q => {
                q.forEach(doc => {
                    let arr = []
                    let type_name = doc.data().type_name;
                    let funds = doc.data().performit_fund_ids;
                    funds.forEach(fund => {
                        arr.push(fund.fund_alias)
                    })
                    let arrayfunds = [...new Set(arr)]
                    Object.assign(this.listOfFunds, {[type_name]: arrayfunds})
                    this.fundTypesDocId[type_name] = doc.id
                })
            })
    }
}
</script>

<style>
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 10px;
}
.add-fund {
    float: right;
}
.header-details {
    /*margin-bottom:10px;*/
    font-size:11px;
    font-style:italic;
    height: 23px;
    color: #909399;
}
.el-table .details-row {
    font-size:12px;
    font-style:italic;
    text-align: right;
}
.el-table .aum-row {
    font-weight:bold;
    background:#f2f2f2;
}
.el-table .lucro-row {
    font-weight:bold;
    background: #ebf1de;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-table .rec-liq-row {
    font-weight:bold;
}
.el-table .rebate-row {
    border-top: 1px solid;
}
.el-main.main {
    padding: 0 10px;
}
.el-footer {
    margin-top: 10px;
}
</style>